export const hotComics = [
  {
    id: "xinghai-jintou",
    title: "星海尽头",
    author: "青野",
    genre: "科幻冒险",
    chapters: 128,
    status: "连载中",
    rating: 9.4,
    tag: "太空歌剧",
    cover: "https://readdy.ai/api/search-image?query=A%20young%20girl%20astronaut%20in%20white%20suit%20standing%20on%20a%20cliff%20overlooking%20a%20vast%20starry%20cosmic%20ocean%2C%20vivid%20orange%20and%20teal%20cel-shaded%20anime%20illustration%2C%20dynamic%20composition%2C%20clean%20flat%20background%2C%20manga%20cover%20art%2C%20high%20detail&width=600&height=800&seq=comic-01&orientation=portrait"
  },
  {
    id: "qingchun-budayan",
    title: "青春不打烊",
    author: "米子",
    genre: "校园日常",
    chapters: 96,
    status: "完结",
    rating: 9.1,
    tag: "青春",
    cover: "https://readdy.ai/api/search-image?query=Cel-shaded%20anime%20illustration%20of%20a%20group%20of%20high%20school%20students%20laughing%20in%20a%20sunny%20schoolyard%20under%20cherry%20blossoms%2C%20warm%20orange%20and%20cream%20palette%2C%20flat%20clean%20background%2C%20manga%20cover%20art%2C%20youthful%20and%20lively&width=600&height=800&seq=comic-02&orientation=portrait"
  },
  {
    id: "yulingshi-ji",
    title: "御灵师记",
    author: "南山客",
    genre: "奇幻仙侠",
    chapters: 210,
    status: "连载中",
    rating: 9.6,
    tag: "国风玄幻",
    cover: "https://readdy.ai/api/search-image?query=Cel-shaded%20anime%20illustration%20of%20a%20heroic%20sword%20warrior%20summoning%20a%20golden%20spirit%20beast%20in%20a%20misty%20mountain%20valley%2C%20ink%20wash%20and%20gold%20tones%2C%20flat%20elegant%20background%2C%20manga%20cover%20art%2C%20high%20detail&width=600&height=800&seq=comic-03&orientation=portrait"
  },
  {
    id: "xiangkou-xiaochidian",
    title: "巷口小吃店",
    author: "阿茶",
    genre: "美食治愈",
    chapters: 154,
    status: "连载中",
    rating: 9.2,
    tag: "治愈日常",
    cover: "https://readdy.ai/api/search-image?query=Cel-shaded%20anime%20illustration%20of%20a%20cozy%20night%20food%20stall%20with%20steaming%20noodles%20and%20warm%20lantern%20glow%2C%20a%20chef%20smiling%2C%20warm%20amber%20and%20orange%20palette%2C%20flat%20clean%20background%2C%20manga%20cover%20art&width=600&height=800&seq=comic-04&orientation=portrait"
  },
  {
    id: "liehun-zhe",
    title: "猎魂者",
    author: "北楼",
    genre: "悬疑冒险",
    chapters: 78,
    status: "连载中",
    rating: 9.0,
    tag: "热血战斗",
    cover: "https://readdy.ai/api/search-image?query=Cel-shaded%20anime%20illustration%20of%20a%20hooded%20hunter%20holding%20a%20glowing%20cyan%20blade%20in%20a%20dark%20ruined%20city%2C%20dramatic%20orange%20rim%20light%2C%20flat%20moody%20background%2C%20manga%20cover%20art%2C%20high%20detail&width=600&height=800&seq=comic-05&orientation=portrait"
  },
  {
    id: "feng-zhi-qishi",
    title: "风之骑士",
    author: "林间",
    genre: "奇幻冒险",
    chapters: 142,
    status: "连载中",
    rating: 9.3,
    tag: "史诗",
    cover: "https://readdy.ai/api/search-image?query=Cel-shaded%20anime%20illustration%20of%20a%20young%20knight%20on%20a%20winged%20steed%20soaring%20over%20clouds%20and%20a%20golden%20castle%2C%20warm%20orange%20and%20gold%20palette%2C%20flat%20clean%20background%2C%20manga%20cover%20art%2C%20epic%20and%20majestic&width=600&height=800&seq=comic-06&orientation=portrait"
  },
  {
    id: "likesheng-de-lianai",
    title: "理科生的恋爱",
    author: "棉棉",
    genre: "恋爱甜宠",
    chapters: 88,
    status: "完结",
    rating: 8.9,
    tag: "轻甜",
    cover: "https://readdy.ai/api/search-image?query=Cel-shaded%20anime%20illustration%20of%20two%20shy%20college%20students%20in%20a%20sunlit%20library%20exchanging%20notes%2C%20soft%20warm%20peach%20and%20cream%20palette%2C%20flat%20gentle%20background%2C%20manga%20cover%20art%2C%20sweet%20romantic%20mood&width=600&height=800&seq=comic-07&orientation=portrait"
  },
  {
    id: "wangpai-qianfeng",
    title: "王牌前锋",
    author: "大佐",
    genre: "运动竞技",
    chapters: 132,
    status: "连载中",
    rating: 9.1,
    tag: "热血",
    cover: "https://readdy.ai/api/search-image?query=Cel-shaded%20anime%20illustration%20of%20a%20striker%20kicking%20a%20soccer%20ball%20under%20stadium%20floodlights%2C%20dramatic%20orange%20sky%2C%20dynamic%20motion%20lines%2C%20flat%20clean%20background%2C%20manga%20cover%20art%2C%20energetic&width=600&height=800&seq=comic-08&orientation=portrait"
  },
];

export const categories = [
  { key: "hot-blood", name: "热血冒险", desc: "燃到上头的战斗与冒险", icon: "ri-fire-fill" },
  { key: "sweet", name: "恋爱甜宠", desc: "心动瞬间与甜甜日常", icon: "ri-heart-3-fill" },
  { key: "fantasy", name: "奇幻仙侠", desc: "仙侠玄幻的想象力世界", icon: "ri-sword-fill" },
  { key: "campus", name: "校园日常", desc: "青春校园的烟火气", icon: "ri-school-fill" },
  { key: "mystery", name: "悬疑烧脑", desc: "反转不断的烧脑故事", icon: "ri-search-eye-fill" },
  { key: "food", name: "美食治愈", desc: "治愈人心的人间烟火", icon: "ri-restaurant-fill" },
  { key: "sports", name: "运动竞技", desc: "挥洒汗水的赛场瞬间", icon: "ri-football-fill" },
  { key: "sci-fi", name: "科幻未来", desc: "星际与未来的想象", icon: "ri-rocket-2-fill" },
];

export const testimonials = [
  {
    name: "阿柠",
    role: "通勤党 · 连载迷",
    content: "每天地铁上没信号，洒洒漫画网的缓存离线看真的救了我。提前把几集缓下来，一路看得停不下来。",
    initial: "柠",
  },
  {
    name: "老麦",
    role: "漫画收集控",
    content: "全集打包收藏太方便了，追了很多年的老番终于能一次性存进手机，换设备也不怕丢。",
    initial: "麦",
  },
  {
    name: "小满",
    role: "学生党",
    content: "零散时间很多，缓存之后随手翻一章。收藏夹整理得明明白白，找起来特别快。",
    initial: "满",
  },
  {
    name: "卷卷",
    role: "夜读用户",
    content: "离线阅读体验很顺，翻页流畅不卡顿。晚上躺床上看也不费眼，强烈安利。",
    initial: "卷",
  },
];

export const faqs = [
  {
    q: "洒洒漫画网缓存漫画需要联网吗？",
    a: "缓存时需要有网络，但缓存完成后即可离线畅读。下载到本地的漫画会保存在你的设备中，无网络、弱网、地铁或飞机上都能随时翻看，完全不消耗流量。",
  },
  {
    q: "漫画全集打包收藏是什么意思？",
    a: "全集打包是指把一部作品的完整章节一次性批量缓存到本地，无需逐集手动操作。收藏后整部作品会整齐地归入你的收藏夹，方便离线阅读与长期留存。",
  },
  {
    q: "缓存后的漫画会占用很大空间吗？",
    a: "占用空间与漫画的分辨率和页数有关。你可以在设置中调整缓存画质，选择标清、高清或原图，按需平衡画面质量与存储占用，释放更多空间给其他内容。",
  },
  {
    q: "如何管理我缓存和收藏的漫画？",
    a: "你可以在收藏夹中按作品、类型、更新时间和阅读进度排序，支持批量管理、批量删除与一键打包，轻松整理庞大的漫画库。",
  },
  {
    q: "更换手机或重新登录后，收藏会丢失吗？",
    a: "只要在重新安装或换设备时选择云端同步收藏，你的书架与阅读进度就会安全同步。本地缓存文件建议先备份，避免意外丢失。",
  },
  {
    q: "缓存离线阅读支持哪些设备？",
    a: "洒洒漫画网适配手机、平板和电脑等多端设备。缓存数据可在支持的设备间共享使用，让你在各种屏幕上都能畅享离线阅读体验。",
  },
];